import { useState } from "react"
import imageCompression from "browser-image-compression"

export const usePhotoUploader = (afterPhotoUploaded: Function) => {
  const [tmpPhoto, setTmpPhoto] = useState<any>(undefined)

  const compressImage = async (file: File) => {
    const options = {
      maxSizeMB: 1,
      maxWidthOrHeight: 1920,
      useWebWorker: true
    }

    try {
      const compressedFile = await imageCompression(file, options)

      return compressedFile
    } catch (error) {
      console.error("Error during image compression: ", error)

      return file
    }
  }

  const uploadToAWS = async (file: File, progressHandler?: (progress: number) => void) => {
    return new Promise(async (resolve, reject) => {
      try {
        const apiUrl = process.env.REACT_APP_API_URL || process.env.REACT_APP_WAKACJE_API_URL || ''
        const response = await fetch(
          `${apiUrl}/v1.1/public/upload-url`,
          { method: "POST" }
        )

        const data = await response.json()
        console.log("Presigned URL data:", data)

        const { uploadUrl, fileUrl, objectKey } = data

        const xhr = new XMLHttpRequest()
        xhr.open("PUT", uploadUrl, true)

        xhr.upload.addEventListener("progress", (e) => {
          if (e.lengthComputable && progressHandler) {
            const percentLoaded = Math.round((100 * e.loaded) / e.total)
            progressHandler(percentLoaded)
          }
        })

        xhr.onreadystatechange = function () {
          if (xhr.readyState === 4) {
            if (xhr.status === 200) {
              resolve({
                url: fileUrl,
                objectKey,
                providerData: {
                  expiresIn: data.expiresIn
                }
              })
            } else {
              reject(new Error(`Upload failed with status ${xhr.status}`))
            }
          }
        }

        xhr.onerror = () => reject(new Error("Upload error"))
        xhr.setRequestHeader("Content-Type", file.type)
        xhr.send(file)

      } catch (err) {
        reject(err)
      }
    })
  }

  const uploadAndStoreFile = async (
    photo: any,
    data: any,
    progressHandler: Function
  ) => {

    const compressedFile = await compressImage(photo.file)
    photo.file = compressedFile

    const uploadedPhoto = await uploadToAWS(photo.file, progressHandler as any)
    return uploadedPhoto
  }

  const loadPhoto = async (inphoto: any, pProgressHandler: any) => {

    const reader = new window.FileReader()

    return new Promise(async (resolve) => {
      reader.onload = async (event: any) => {
        if (event.type === "load") {
          const data = event.target.result
          let photo = {
            ...inphoto,
            loadStatus: "uploading",
            data
          }
          if (pProgressHandler) {
            pProgressHandler(inphoto.photoId, { data })
          }

          setTmpPhoto(photo)
          const progressHandler = (percentUploaded: any) => {
            const photo = {
              ...inphoto,
              loadStatus: "uploading",
              data,
              percentUploaded
            }
            if (pProgressHandler) {
              pProgressHandler(inphoto.photoId, { progress: percentUploaded })
            }
            setTmpPhoto(photo)
          }
          const res: any = await uploadAndStoreFile(
            photo,
            data,
            progressHandler
          )

          const pphoto: any = {
            id: photo.id,
            ...res,
            sourceUrl: res.url,
            sourceType: "b2_url",
            loadStatus: "uploaded"
          }
          resolve(pphoto)
        }
      }
      const photo = { ...inphoto, loadStatus: "loading" }
      reader.readAsArrayBuffer(inphoto.file)
    })
  }

  const handleNewPhotoSelected = async (photo: any, progressHandler: any) => {
    setTmpPhoto(photo)
    const res = await loadPhoto(photo, progressHandler)
    return res
  }
  const handleReset = () => {
    setTmpPhoto(undefined)
  }
  return {
    tmpPhoto,
    onPhotoSelected: handleNewPhotoSelected,
    reset: handleReset
  }
}
